import { Pipe, PipeTransform } from '@angular/core';

/**
 * Finds an object from given source using the given key - value pairs
 */
@Pipe({
    name: 'fuseSelectSearch',
    pure: false
})
export class FuseSelectSearchPipe implements PipeTransform
{
    /**
     * Constructor
     */
    constructor()
    {
    }

    /**
     * Transform
     *
     * @param items dropdown list
     * @param searchTxt value to search
     */

    transform(items: any[], searchTxt: string, module: string): any[] {
        if(!items || !items.length) return items;
        if(!searchTxt || !searchTxt.length) return items;

        switch(module) {
            case '[PROJECT CUSTOMER]': {
                return items.filter(item => {
                    const nameCheck =  item.companyName && item.companyName.toLowerCase().indexOf(searchTxt.toLowerCase())
                    const lwIdCheck =  item.lwId && item.lwId.toString().toLowerCase().indexOf(searchTxt.toLowerCase())
                    return nameCheck > -1 || lwIdCheck > -1
                });
            }
            case '[CUSTOMER CONTACT MOVE]': {
                return items.filter(item => {
                    const companyNameCheck =  item.companyName && item.companyName.toLowerCase().indexOf(searchTxt.toLowerCase())
                    const cityCheck =  item?.city &&  item?.city.toLowerCase().indexOf(searchTxt.toLowerCase())
                    const lwIdCheck =  item.lwId && item.lwId.toString().toLowerCase().indexOf(searchTxt.toLowerCase())
                    return companyNameCheck > -1 || cityCheck > -1 || lwIdCheck > -1
                  });
            }
            case '[PROJECT QUICK-ADD CUSTOMER]': {
                return items.filter(item => {
                    const companyNameCheck =  item.companyName && item.companyName.toLowerCase().indexOf(searchTxt.toLowerCase())
                    const cityCheck =  item?.city &&  item?.city.toLowerCase().indexOf(searchTxt.toLowerCase())
                    const lwIdCheck =  item.lwId && item.lwId.toString().toLowerCase().indexOf(searchTxt.toLowerCase())
                    return companyNameCheck > -1 || cityCheck > -1 || lwIdCheck > -1
                  });
            }
            case '[PROJECT QUICK-ADD SKILLS]': {
                return items.filter(item => {
                    const skillName =  item.name && item.name.toLowerCase().indexOf(searchTxt.toLowerCase())
                    return skillName > -1
                  });
            }
            case '[COUNTRY-CODE]': {
                return items.filter(item => {
                    const code =  item.dialCode && item.dialCode.toLowerCase().indexOf(searchTxt.toLowerCase())
                    const country =  item.name && item.name.toLowerCase().indexOf(searchTxt.toLowerCase())
                    return code > -1 || country > -1
                  });
            }
            case '[TASK SEARCH USER]': {
                return items.filter(item => {
                    const firstNameCheck =  item.firstName && item.firstName.toLowerCase().indexOf(searchTxt.toLowerCase())
                    const lastNameCheck =  item?.lastName &&  item?.lastName.toLowerCase().indexOf(searchTxt.toLowerCase())
                    return lastNameCheck > -1 || firstNameCheck > -1
                  });
            }
            case '[CONVERT PROJECT SEARCH APPLICANT]': {
                return items.filter(item => {
                    const firstNameCheck =  item.firstName && item.firstName.toLowerCase().indexOf(searchTxt.toLowerCase())
                    const lastNameCheck =  item?.name &&  item?.name.toLowerCase().indexOf(searchTxt.toLowerCase())
                    return lastNameCheck > -1 || firstNameCheck > -1
                  });
            }
            default: {
                return items.filter(item => {
                    const find =  item[module] && item[module].toLowerCase().indexOf(searchTxt.toLowerCase())
                    return find > -1
                  });
            }
        }
      }
}
